// extracted by mini-css-extract-plugin
export default {"wrapper":"BrainSlices_wrapper__Nrmcg"};